import { useState } from "react";
import { updatePassword } from "../lib/db";

/**
 * Shown when the user lands from a password-reset email link (recovery session).
 * Lets them set a new password, then continues into the app.
 */
export default function ResetPasswordScreen({ onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const canSubmit = password.length >= 6 && password === confirm;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setError("");
    setLoading(true);
    try {
      await updatePassword(password);
      onDone();
    } catch (e) {
      setError(e.message || "Couldn't update your password. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="brand-logo mb-8">
        <span className="brand-mark">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M15 4L22 18H8L15 4Z" fill="currentColor" opacity="0.3"/><path d="M9 8L17 18H1L9 8Z" fill="currentColor"/></svg>
        </span>
        <span className="brand-text brand-text--lg">elevate</span>
      </div>
      <div className="auth-heading">Set a new password</div>

      <div className="auth-form">
        <div className="field">
          <label>New password</label>
          <input
            type="password"
            placeholder="Min 6 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
          />
        </div>
        <div className="field">
          <label>Confirm password</label>
          <input
            type="password"
            placeholder="Re-enter password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && canSubmit && handleSubmit()}
            autoComplete="new-password"
          />
        </div>

        {confirm.length > 0 && password !== confirm && (
          <div className="alert alert-error">Passwords don't match</div>
        )}
        {error && <div className="alert alert-error">{error}</div>}

        <button
          className="btn btn-primary btn-full"
          style={{ opacity: loading ? 0.5 : 1 }}
          onClick={handleSubmit}
          disabled={!canSubmit || loading}
        >
          {loading ? (
            <span className="flex-center-gap-8" style={{ justifyContent: "center" }}>
              <span className="spinner-sm" />
              Updating...
            </span>
          ) : (
            "Update Password"
          )}
        </button>
      </div>
    </div>
  );
}
